<div class="mat-card mat-elevation-z2 p-24" fxLayout="column">
    <mat-chip-list fxFlex="100" fxFlexFill>
        <mat-chip class="example-box primary">
            OOTT - {{ detalleOOTT.idOrdenTrabajo }}</mat-chip
        >
        <mat-icon>chevron_right</mat-icon>
        <mat-chip class="example-box warn">
            Ticket - {{ detalleOOTT.ticket }}
        </mat-chip>
        <mat-icon>chevron_right</mat-icon>
        <mat-chip class="example-box accent">
            OOCC - {{ detalleOOTT.ordenCompra?.numero }}
        </mat-chip>
    </mat-chip-list>
    <br />
    <mat-divider></mat-divider>
    <br />

    <div fxLayout="column" fxFlex="100" fxFlexFill>
        <div class="h1 pr-16">OOTT ({{ detalleOOTT.estado.descripcion }})</div>
    </div>
    <div fxLayout="row" fxLayoutAlign="start start" fxLayout.lt-md="column">
        <mat-list fxLayoutGap="200px" fxFlex.lt-md="100">
            <mat-list-item>
                <h3 matLine>Servicio</h3>
                <p matLine>
                    <span class="text-bold"
                        >{{ detalleOOTT.servicio.descripcion }}
                        {{ detalleOOTT.servicio.atributos.join(", ") }}
                    </span>
                </p>
            </mat-list-item>

            <mat-list-item *ngIf="detalleOOTT.servicio.id !== 0">
                <h3 matLine>Cantidad / Tiempo</h3>
                <p matLine>
                    {{ detalleOOTT.servicio.cantidad }}
                    {{ detalleOOTT.servicio.unidadMedida?.descripcion }}
                </p>

                <p matLine>
                    {{ detalleOOTT.servicio.tiempo }}
                    {{ detalleOOTT.servicio.unidadTiempo?.descripcion }}
                </p>
            </mat-list-item>

            <mat-list-item>
                <h3 matLine>Cliente</h3>
                <p matLine>
                    <span class="text-bold"
                        >{{ detalleOOTT.servicio.sucursal.cliente.nombre }} ({{
                            detalleOOTT.servicio.sucursal.cliente.rut
                        }})</span
                    >
                </p>
            </mat-list-item>

            <mat-list-item>
                <h3 matLine>Sucursal</h3>
                <p matLine>
                    <span class="secondary-text">
                        {{ detalleOOTT.servicio.sucursal.nombre }} <br />
                        {{ detalleOOTT.servicio.sucursal.direccion }},
                        {{ detalleOOTT.servicio.sucursal.comuna.nombre }}</span
                    >
                </p>
            </mat-list-item>

            <mat-list-item>
                <h3 matLine>Valor</h3>
                <p matLine>
                    <span class="secondary-text"
                        >UF {{ detalleOOTT.servicio.valorUF }}</span
                    >
                </p>
                <p matLine>
                    <span class="secondary-text">
                        {{
                            detalleOOTT.servicio.valorCLP
                                | currency: "CLP":"symbol-narrow"
                        }}</span
                    >
                </p>
            </mat-list-item>

            <mat-list-item class="mt-16 mb-8">
                <div matLine>
                    <h3>
                        Contratista
                        <button
                            *ngIf="
                                _menuUsuarioSrvc.esSupervisor() &&
                                detalleOOTT.estado.id !==
                                    config.oott.estados.anulada.id &&
                                !detalleOOTT?.trabajo?.contratista
                            "
                            mat-mini-fab
                            (click)="asignarContratista()"
                        >
                            <mat-icon>work_outline</mat-icon>
                        </button>
                        <br/>
                        <span *ngIf="
                        (_menuUsuarioSrvc.esEncargado() || _menuUsuarioSrvc.esRepresentante()) &&
                        detalleOOTT.estado.id !==
                            config.oott.estados.anulada.id &&
                        !detalleOOTT?.trabajo?.contratista
                    ">
                            Facilitic esta buscando un contratista....
                        </span>

                    </h3>
                </div>

                <div
                    class="cursor-pointer"
                    matLine
                    *ngIf="detalleOOTT?.trabajo?.contratista"
                    fxLayout="row"
                    fxLayoutAlign="start start"
                    fxLayoutGap="14px"
                    (click)="
                        abrirFichaContratista(
                            detalleOOTT.trabajo.contratista.nrRut
                        )
                    "
                >
                    <div *ngIf="fotoContratista">
                        <img
                            class="avatar-imagen-mini"
                            [src]="fotoContratista"
                            [alt]="
                                detalleOOTT.trabajo.contratista.nombres +
                                ' ' +
                                detalleOOTT.trabajo.contratista.apellidos
                            "
                        />
                    </div>

                    <div>
                        <strong
                            >{{ detalleOOTT.trabajo.contratista.nombres }}
                            {{
                                detalleOOTT.trabajo.contratista.apellidos
                            }}</strong
                        >
                        <br />
                        <small>
                            {{ detalleOOTT.trabajo.contratista.rut }}</small
                        >
                        <br />
                        <app-star-rating
                            [seteable]="false"
                            [evaluacion]="
                                detalleOOTT.trabajo.contratista.evaluacion
                            "
                            [rutContratista]="
                                detalleOOTT.trabajo.contratista.nrRut
                            "
                        ></app-star-rating>
                    </div>
                    <div
                        *ngIf="
                            detalleOOTT.trabajo &&
                            detalleOOTT.trabajo.estado.id ===
                                config.trabajo.estados.pagado.id &&
                            _menuUsuarioSrvc.esSupervisor()
                        "
                    >
                        <mat-icon color="primary" matTooltip="Pago informado"
                            >monetization_on</mat-icon
                        >
                    </div>
                </div>
            </mat-list-item>
        </mat-list>

        <mat-list fxFlexFill fxFlex.lt-md="100">
            <div>
                <mat-list-item>
                    <h3 matLine>Fecha OOTT</h3>
                    <p matLine>
                        <span class="secondary-text">{{
                            detalleOOTT.fecha | date: "dd-MM-yyyy"
                        }}</span>
                    </p>
                </mat-list-item>

                <mat-list-item>
                    <h3 matLine>Fecha inicio</h3>
                    <p matLine>
                        <span class="secondary-text">{{
                            detalleOOTT.trabajo?.fechaInicioSolicitado
                                ? (detalleOOTT.trabajo.fechaInicioSolicitado
                                  | date: "dd-MM-yyyy")
                                : (detalleOOTT.servicio.sucursal.cliente
                                      .fechaInicio | date: "dd-MM-yyyy")
                        }}</span>
                    </p>
                </mat-list-item>

                <mat-list-item>
                    <h3 matLine>Fecha término</h3>
                    <p matLine>
                        <span class="secondary-text">
                            {{
                                detalleOOTT.trabajo?.fechaTerminoSolicitado
                                    ? (detalleOOTT.trabajo
                                          .fechaTerminoSolicitado
                                      | date: "dd-MM-yyyy")
                                    : (detalleOOTT.servicio.sucursal.cliente
                                          .fechaTermino | date: "dd-MM-yyyy")
                            }}</span
                        >
                    </p>
                </mat-list-item>
                <mat-list-item>
                    <h3 matLine>Observación</h3>
                    <p matLine>
                        <span class="secondary-text">{{
                            detalleOOTT.servicio.descripcionSolicitud
                        }}</span>
                    </p>
                </mat-list-item>

                <mat-list-item>
                    <h3 matLine>Descripción trabajo</h3>
                    <p matLine>
                        <span class="secondary-text">{{
                            detalleOOTT.servicio.descripcionTrabajo
                        }}</span>
                    </p>
                </mat-list-item>

                <mat-list-item *ngIf="detalleOOTT.servicio.id !== 0">
                    <h3 matLine>Condición</h3>
                    <p matLine>
                        <span class="secondary-text">{{
                            detalleOOTT.servicio.condicion.descripcion
                        }}</span>
                    </p>
                </mat-list-item>

                <mat-list-item>
                    <h3 matLine>Tiempo trabajo</h3>
                    <p matLine>
                        <span class="secondary-text">{{
                            detalleOOTT.servicio.tiempoTrabajo
                        }}</span>&nbsp;días
                    </p>
                </mat-list-item>

                <mat-list-item *ngIf="detalleOOTT.servicio.id === 0">
                    <h3 matLine>Documento adjunto</h3>
                    <p matLine>
                        <span class="secondary-text">
                            <button
                                mat-icon-button
                                type="button"
                                color="accent"
                                (click)="descargar()"
                            >
                                <mat-icon>cloud_download</mat-icon> Descargar
                            </button>
                        </span>
                    </p>
                </mat-list-item>
            </div>
        </mat-list>
    </div>

    <div
        class="p-8 pt-16 mt-24"
        fxFlexFill
        fxLayout="column"
        fxFlex="100"
        fxLayoutAlign="start start"
    >
        <div>
            <button
                *ngIf="detalleOOTT.trabajo"
                mat-button
                color="accent"
                (click)="verAvance(detalleOOTT.trabajo.id)"
            >
                <mat-icon>timeline</mat-icon>
                VER AVANCE DEL TRABAJO
            </button>
            <button
                mat-button
                color="accent"
                (click)="recibir()"
                *ngIf="
                    detalleOOTT.estado.id ===
                        config.oott.estados.terminada.id &&
                    _menuUsuarioSrvc.esEncargado() &&
                    _menuUsuarioSrvc.puedeRealizarAccion(
                        detalleOOTT.servicio.sucursal.id,
                        'puedeRecibir'
                    )
                "
            >
                <mat-icon>assignment_turned_in</mat-icon>
                RECIBIR TRABAJO
            </button>
            <button
                mat-button
                color="accent"
                (click)="corregir()"
                *ngIf="
                    detalleOOTT.estado.id ===
                        config.oott.estados.conObservaciones.id &&
                    _menuUsuarioSrvc.esSupervisor()
                "
            >
                <mat-icon>assignment_turned_in</mat-icon>
                CORREGIR OBSERVACIONES
            </button>

            <button
                mat-button
                color="accent"
                (click)="evaluar()"
                *ngIf="
                    detalleOOTT.trabajo &&
                    detalleOOTT.estado.id ===
                        config.oott.estados.terminada.id &&
                    _menuUsuarioSrvc.esSupervisor() &&
                    detalleOOTT.trabajo.evaluacionSupervisor === null
                "
            >
                <!--se debe agregar un && dependiendo del perfil !evaluacionCliente || !evaluacionSupervisor-->
                <mat-icon>star_rate</mat-icon>
                CALIFICAR CONTRATISTA
            </button>

            <button
                mat-button
                color="accent"
                (click)="informarPago(detalleOOTT.trabajo.id)"
                *ngIf="
                    detalleOOTT.trabajo &&
                    detalleOOTT.estado.id ===
                        config.oott.estados.recepcionada.id &&
                    detalleOOTT.trabajo.estado.id !==
                        config.trabajo.estados.pagado.id &&
                    _menuUsuarioSrvc.esSupervisor()
                "
            >
                <mat-icon>monetization_on</mat-icon>
                INFORMAR PAGO A CONTRATISTA
            </button>
            <button
                mat-button
                color="warn"
                *ngIf="
                    (detalleOOTT.estado.id === config.oott.estados.enviada.id ||
                        detalleOOTT.estado.id ===
                            config.oott.estados.nueva.id ||
                        detalleOOTT.estado.id ===
                            config.oott.estados.planificada.id) &&
                    !detalleOOTT.trabajo
                "
                (click)="anularOOTT()"
            >
                <mat-icon>cancel</mat-icon>
                ANULAR OOTT
            </button>

            <button
                mat-button
                color="accent"
                (click)="anularTrabajo()"
                *ngIf="
                    detalleOOTT.trabajo &&
                    _menuUsuarioSrvc.esSupervisor() &&
                    detalleOOTT.estado.id !== config.oott.estados.anulada.id &&
                    detalleOOTT.estado.id !==
                        config.oott.estados.recepcionada.id &&
                    detalleOOTT.estado.id !==
                        config.oott.estados.conObservaciones.id &&
                    detalleOOTT.estado.id !== config.oott.estados.terminada.id
                "
            >
                <mat-icon>work_off</mat-icon>
                ANULAR TRABAJO
            </button>
            <button
                mat-button
                color="accent"
                (click)="descargarOOTT()"
                *ngIf="
                    detalleOOTT.trabajo &&
                    detalleOOTT.estado.id ===
                        config.oott.estados.recepcionada.id
                "
            >
                <mat-icon>cloud_download</mat-icon>
                DESCARGAR OOTT
            </button>
            <!--<button
                mat-button
                color="accent"
                *ngIf="
                    _menuUsuarioSrvc.esSupervisor() &&
                    detalleOOTT.estado.id !== config.oott.estados.anulada.id &&
                    this.detalleOOTT.servicio.grupoServicio.id === 0
                "
                (click)="asignarContratista(true)"
            >
                <mat-icon>attach_money</mat-icon>
                INVITAR A COTIZAR
            </button>-->

            <button
                mat-button
                color="accent"
                (click)="verPersonalApoyo(detalleOOTT.trabajo.personalApoyo)"
                *ngIf="detalleOOTT.trabajo?.personalApoyo"
            >
                <mat-icon>people_outline</mat-icon>
                PERSONAL APOYO
            </button>

            <button
                mat-button
                color="accent"
                (click)="verInvitaciones()"
                *ngIf="
                    _menuUsuarioSrvc.esSupervisor() &&
                    detalleOOTT?.trabajo?.contratista
                "
            >
                <mat-icon>recent_actors</mat-icon>
                VER INVITACIONES
            </button>
        </div>
    </div>
</div>
